import "./SwitchViewRange.scss";
import type { ReactNode } from "react";
import ViewRangeButton from "@/pages/human-resources/time-management/components/switch-view-range/ViewRangeButton.tsx";
import { allScheduleRanges } from "@/pages/human-resources/time-management/model/ScheduleRange.ts";
import useScheduleUrls from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/useScheduleUrls.ts";
import type { ScheduleOrAnalysis } from "@/pages/human-resources/time-management/components/switch-schedule-analysis/SwitchScheduleAnalysis.tsx";
import useScheduleRangeOnRoute from "@/pages/human-resources/time-management/hooks/useScheduleRangeOnRoute.ts";

interface Properties {
  viewType: ScheduleOrAnalysis;
}

export default function SwitchViewRange(props: Properties): ReactNode {
  const currentRange = useScheduleRangeOnRoute();
  const scheduleUrls = useScheduleUrls(props.viewType);

  return (
    <div className="switch-day-week-month">
      {allScheduleRanges.map((range) => (
        <ViewRangeButton
          range={range}
          selected={range === currentRange}
          key={range}
          url={scheduleUrls.toRange(range)}
          disabled={props.viewType === "analysis" && range === "WEEK"}
        />
      ))}
    </div>
  );
}
